module.exports = __webpack_public_path__ + "10fd74ff5b4f6e252d59425c08b3ecc1.MP3";